import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { CommonService }            from './common.service';
import { PdfInterfaceService }      from './pdf.interface.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class SupplierService implements PdfInterfaceService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'supplier', snackbar);
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.getItems(filter);
    }

    public insertItem(item: any): Observable<any> {
        return this._commonService.insertItem(item);
    }

    public updateItem(id: string, item: any): Observable<any> {
       return this._commonService.updateItem(id, item);
    }

    public deleteItem(id: string): Observable<any> {
        return this._commonService.deleteItem(id);
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public pdfUrl(filter: ISortableFilter, columnParams: Array<any>) {
        this._commonService.pdfUrl(filter, columnParams);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/supplier.service.ts